import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import React from 'react';
import TextField from './Common/TextField';

interface Props {
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export const SearchField = ({ value, onChange }: Props) => {
  return (
    <TextField
      startIcon={<MagnifyingGlassIcon className="h-4 w-4 text-gray-500" />}
      fullWidth
      className="h-8 w-full"
      value={value}
      onChange={onChange}
      placeholder="Search"
    />
  );
};
